/**
 * --------------------------------------------------------------------------
 * Button visually impaired (v1.0.0): util/cookie.js
 * Licensed under MIT (https://github.com/veks/button-visually-impaired-javascript/blob/master/LICENSE.md)
 * --------------------------------------------------------------------------
 */

function setCookie(name, value, days = 7) {
  const now = new Date();
  now.setTime(now.getTime() + days * 24 * 60 * 60 * 1000); // Устанавливаем время истечения через заданное количество дней
  const expires = now.toUTCString();

  document.cookie = `bvi_${encodeURIComponent(name)}=${encodeURIComponent(value)};path=/;expires=${expires};domain=${window.location.hostname}`;
}

const getCookie = function (name = '') {
  name = `bvi_${name}=`;
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookies = decodedCookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();

    if (cookie.indexOf(name) !== -1) {
      return cookie.substring(name.length, cookie.length);
    }
  }
};

const removeCookie = function (name = '') {
  document.cookie = `bvi_${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${window.location.host}`;
};

export {
  setCookie,
  getCookie,
  removeCookie,
};
